import { AutoLockFormsLevelType, FormNames } from '../autoLockForms.constants';

const formFields = [
  {
    name: 'mersTransferBatchNumber',
    label: 'MERS Transfer Batch Number',
    levelType: AutoLockFormsLevelType.FIELD,
  },
  {
    name: 'mersTransferDate',
    label: 'MERS Transfer Date',
    levelType: AutoLockFormsLevelType.FIELD,
  },
  {
    name: 'mersTransferAcceptedDate',
    label: 'MERS Transfer Accepted Date',
    levelType: AutoLockFormsLevelType.FIELD,
  },
  {
    name: 'minRegistrationReversedDate',
    label: 'MIN Registration Reversed Date',
    levelType: AutoLockFormsLevelType.FIELD,
  },
  {
    name: 'minRegistrationReversalReason',
    label: 'MIN Registration Reversal Reason',
    levelType: AutoLockFormsLevelType.FIELD,
  },
  {
    name: 'minDeactivatedDate',
    label: 'MIN Deactivated Date',
    levelType: AutoLockFormsLevelType.FIELD,
  },
  {
    name: 'minDeactivationType',
    label: 'MIN Deactivation Type',
    levelType: AutoLockFormsLevelType.FIELD,
  },
];

export const mersInformationForm = {
  name: FormNames.POST_CLOSING,
  label: 'MERS',
  levelType: AutoLockFormsLevelType.FORM,
  children: formFields,
};
